// React
import { useHistory } from 'react-router-dom';
import React, { useState, useEffect } from 'react';

// Containers Injection
import { createData } from './utils/createData';
import { CredentialsNTInjection } from '../../containers/credentialsNTInjection';

// View
import { CredentialsNTPage } from './view';

// Utils
import { columns } from './utils/columns';
import { APIClient } from '../../../../helpers/api_helper';

export const CredentialsNT = ({ keysSearch = ['name'] }) => {
  let savedSearch = sessionStorage.getItem('search');
  let savedFilters = JSON.parse(sessionStorage.getItem('filtersCredentialsNT'));

  const [city, setCity] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [neighborhoods, setNeighborhoods] = useState([]);
  const [search, setSearch] = useState(savedSearch || '');
  const [activeStatus, setActiveStatus] = useState('true');
  const [modal_animationLeft, setmodal_animationLeft] = useState(false);
  const [filtersParams, setFiltersParams] = useState(
    savedFilters || {
      state: '',
      city: '',
      neigh: '',
      specialty: '',
    }
  );

  const {
    states,
    successDelete,
    credentialsNT,
    getCredentialsNT,
    deleteCredentialsNT,
    getCredentialsNTStates,
    specialties_credentialsNT,
    getCredentialsNTSpecialties,
  } = CredentialsNTInjection();

  const api = new APIClient();
  const history = useHistory();

  function tog_animationLeft() {
    setmodal_animationLeft(!modal_animationLeft);
  }

  // GET calls
  const getFilterCities = async (e) => {
    await api
      .get(`register/provider/cities/${e}`)
      .then((response) => {
        setCity(createData(response.data));
      })
      .catch((err) => console.log(err));
  };

  const getFilterNeighborhoods = async (e) => {
    await api
      .get(`register/provider/neighborhoods/${e}`)
      .then((response) => {
        setNeighborhoods(createData(response.data));
      })
      .catch((err) => console.log(err));
  };

  // Handle's functions
  const handleEdit = (values) => {
    const { id } = values;
    setmodal_animationLeft(true);

    history.push(`/rede-credenciada/edit/${id}`);
  };

  const handleDelete = (id) => {
    deleteCredentialsNT(id);
  };

  const handleDuplicate = (credential) => {
    history.push(`/rede-credenciada/novo/${credential.id}`);
  };

  const handleSelectChange = (fieldName, eventInput) => {
    if (!eventInput) {
      setFiltersParams((prevState) => ({
        ...prevState,
        [fieldName]: '',
      }));
    } else {
      setFiltersParams((prevState) => ({
        ...prevState,
        [fieldName]: eventInput.value,
      }));
    }
  };

  // Search's functions
  const handleSearchLocal = (event) => {
    setSearch(event);

    sessionStorage.setItem('search', event);

    if (event === null) {
      setFilteredData([]);
      return;
    }

    let newData = [];

    (keysSearch || []).map((key) => {
      let newArr = credentialsNT.filter((item) => {
        if (item[key]) {
          return normalizeItem(item[key], event);
        }
      });
      newData = newData.concat(
        newArr.filter((item) => newData.indexOf(item) < 0)
      );
    });

    setFilteredData(newData);
  };

  const normalizeItem = (item, event) => {
    return item
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^\w\s]|_/g, '')
      .toLowerCase()
      .trim()
      .includes(
        event
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/[^\w\s]|_/g, '')
          .trim()
      );
  };

  useEffect(() => {
    getCredentialsNTStates();
  }, []);

  useEffect(() => {
    getCredentialsNTSpecialties(filtersParams);
    sessionStorage.setItem(
      'filtersCredentialsNT',
      JSON.stringify(filtersParams)
    );

    if (filtersParams.state) {
      getFilterCities(filtersParams.state);
    }

    if (filtersParams.city) {
      getFilterNeighborhoods(filtersParams.city);
    }
  }, [filtersParams]);

  useEffect(() => {
    getCredentialsNT(activeStatus, filtersParams);
  }, [activeStatus, filtersParams, successDelete]);

  useEffect(() => {
    if (!savedSearch) {
      setSearch('');
      setFilteredData(credentialsNT);
    } else {
      handleSearchLocal(savedSearch);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [savedSearch, credentialsNT]);

  return (
    <CredentialsNTPage
      // utils
      history={history}
      columns={columns}
      filtersParams={filtersParams}
      setFiltersParams={setFiltersParams}
      setActiveStatus={setActiveStatus}
      // functions
      handleEdit={handleEdit}
      handleDelete={handleDelete}
      handleDuplicate={handleDuplicate}
      getFilterCities={getFilterCities}
      handleSearchLocal={handleSearchLocal}
      tog_animationLeft={tog_animationLeft}
      handleSelectChange={handleSelectChange}
      getFilterNeighborhoods={getFilterNeighborhoods}
      // data
      city={city}
      search={search}
      states={states.data}
      filteredData={filteredData}
      neighborhoods={neighborhoods}
      specialties={specialties_credentialsNT.data}
      credentialsNT={credentialsNT ? credentialsNT : []}
    />
  );
};
